import Component from '../abstracts/Component';

export default class HeaderComponent extends Component {
    constructor(compEl) {
        console.log('HeaderComponent init');
        super(compEl);

        const btnOpen = document.querySelector("#navMenu-open")
        const btnClose = document.querySelector("#navMenu-close")
        const navMenu = document.querySelector("#navMenu")
        const body = document.querySelector("body")
        const langSelectors = [...document.querySelectorAll(".langSelector")]

        langSelectors.forEach((element) => {
            element.onchange = (event) => {
                window.location = event.target.value
            }
        })

        btnOpen.onclick = (event) => {
            event.preventDefault();

            navMenu.classList.toggle("c-navMenu--open", true)
            body.style.overflow = "hidden"
        }

        btnClose.onclick = (event) => {
            event.preventDefault();

            navMenu.classList.toggle("c-navMenu--open", false)
            body.style.overflow = null
        }

        window.addEventListener("scroll", () => this.updateHeader(compEl));
        this.updateHeader(compEl);
    }

    init() {
        super.init();
    }

    updateHeader(el) {
        const scrollpos = window.scrollY;
        el.classList.toggle("c-header--fixed", scrollpos > 0);
    }
}
